import React, {useEffect, useState} from "react";

import {SearchSelectWithList} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";
import {getBooleanDisplayIcon} from "../../../../helpers/utils/Utils";
import {useGetAllStatesQuery} from "../../states/statesApi";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {
    useLazyGetAllCountyByStateAbbrQuery,
} from "../../counties/countiesApi";
import IconButton from "../../../../components/common/form/IconButton";
import {FaPlus} from "react-icons/fa6";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {useNavigate} from "react-router-dom";
import {useLazyExportCollectorDataQuery, useSearchCollectorQuery} from "../collector";

const Collectors = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Collectors", url: ""}]
    )
    const navigate = useNavigate()
    const {data: userSettings} = useFindUserSettingsByGroupNameQuery("Collectors");
    const stateData = useGetAllStatesQuery("");
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()
    const [triggerExportCollectorDataQuery] = useLazyExportCollectorDataQuery();

    useEffect(() => {
        document.title = 'Collectors';
    }, []);

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            cell: (props: any) => {
                let path = `/collectors/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["COLL-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                                                     accessor={"name"}/>,
            }]
        },

        {
            label: "State", accessor: "state.stateAbbreviation",
            filterOptions: [{
                dependentColumns: ["County"],
                filterComponent: SearchSelectWithList(stateData?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),
                overrideFilterLabel: "State",
                overrideFilterAccessor: "state"
            }]
        },
        {
            label: "County", accessor: "countyName",
            filterOptions: [{
                filterComponent: SearchSelectWithList(getAllCountyByStateAbbrApiResponse?.data, "countyName", "id", "Select County...", false, "countyId"),
                onDependencyUpdated: (value: string) => {
                    getAllCountyByStateAbbrApi(value);
                },
                overrideFilterAccessor: "countyId",
            }]
        },

        {
            label: "Is Primary Collector",
            accessor: "isPrimaryCollector",
            cell: (props: any) => getBooleanDisplayIcon(props.value, "Enabled", "Disabled"),
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Is Primary Collector...", "primaryCollector"),
                overrideFilterAccessor: "primaryCollector",
                overrideFilterLabel: "Is Primary",
            }]
        },
    ]

    return (
        <div className="user-container px-5 py-5">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs}/>
                </div>
                            <DataTable
                                columns={columns}
                                actions={{
                                    fetchAction: useSearchCollectorQuery,
                                    exportAction: triggerExportCollectorDataQuery
                                }}
                                userSettingGroup={"Collector"}
                                defaultSortOptions={{
                                    accessor: "name",
                                    direction: "asc"
                                }}
                                buttonOptions={{
                                    addButton:
                                        {
                                            button: <IconButton
                                                icon={<FaPlus/>}
                                                hasBackground={true}
                                                onClick={() => {
                                                    navigate("/collectors/create")
                                                }}
                                                title={"Add County"}
                                            />,
                                            permissions: ["COLL-C"]
                                        },
                                }}
                                basePermission={"COLL"}
                            />
                    
                </div>
    );
};

export default Collectors;